var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_3811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 0C4.47711 0 0 4.47711 0 9.99998C0 15.5229 4.47711 20 9.99998 20C15.5229 20 20 15.5229 20 9.99998C20 4.47711 15.5228 0 9.99998 0ZM7.33197 14.8345H5.13637V7.74116H7.33197V14.8345ZM6.22371 6.81224C5.50665 6.81224 4.92534 6.2262 4.92534 5.50339C4.92534 4.78051 5.50673 4.19451 6.22371 4.19451C6.94068 4.19451 7.52199 4.78051 7.52199 5.50339C7.52203 6.22624 6.94072 6.81224 6.22371 6.81224ZM15.56 14.8345H13.375V11.1111C13.375 10.0899 12.9871 9.51981 12.1796 9.51981C11.3008 9.51981 10.8416 10.1135 10.8416 11.1111V14.8345H8.7358V7.74116H10.8416V8.69652C10.8416 8.69652 11.4751 7.5248 12.9792 7.5248C14.4833 7.5248 15.56 8.4432 15.56 10.3431L15.56 14.8345Z",
    fill: "url(#paint0_linear_39_3811)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39_3811",
    x1: 2.92892,
    y1: 2.92892,
    x2: 17.071,
    y2: 17.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2489BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0575B3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_3811"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLinkedin);
export default __webpack_public_path__ + "static/media/logo_linkedin.17daf127a0e2a33e0bb195063350e28a.svg";
export { ForwardRef as ReactComponent };